"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookieValue = getCookieValue;
exports.parseOneTrustCookie = parseOneTrustCookie;
var ONETRUST_COOKIE = 'OptanonConsent';
function getCookieValue(cname, defaultValue) {
  // `getClientEnvironmentDetails` could provide this information, but imports
  // the "bowser" package to decorate a bunch of details we don't need (that's ~5k minified)
  // As such, we'll just lift the line we actually want:
  // https://code.corp.surveymonkey.com/webplatform/smpackages/blob/master/packages/utils/src/environment/index.ts#L83
  var isBrowser = typeof window === 'object';
  if (!isBrowser) return '';
  var name = "".concat(cname, "=");
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i += 1) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return defaultValue || '';
}

/**
 * Checks for and parses the information stored in the OneTrust cookie
 *
 * @returns Whether the OneTrust cookie exists and the information stored within it
 */
function parseOneTrustCookie() {
  var cookieValue = getCookieValue(ONETRUST_COOKIE, '');
  var retVal = {
    hasOneTrustCookie: !!cookieValue,
    keyValues: {},
    groups: {}
  };
  if (retVal.hasOneTrustCookie) {
    cookieValue.split('&').forEach(function (token) {
      var keyVal = token.split('=').map(function (piece) {
        return decodeURIComponent(piece);
      });
      var key = keyVal.shift();
      var value = keyVal.length ? keyVal.shift() : true;
      if (key) {
        retVal.keyValues[key] = value;
      }
    });

    // fix up groups to be cleaner
    if (typeof retVal.keyValues.groups === 'string') {
      retVal.keyValues.groups.split(',').forEach(function (group) {
        var tokens = group.split(':');
        retVal.groups[tokens[0]] = tokens[1] === '1';
      });
    }
  }
  return retVal;
}
//# sourceMappingURL=utils.js.map